import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { EmptyStateExampleCompanyProfilesCTA } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/ctas/empty-state-example-company-profiles-cta';
import { EmptyInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/empty-info-box';
import { EmptyStateNoDataAccess } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/no-access';
import { LensDataAccess } from '@upright/ui/common/upright/core/impact-lens-profile/types';
import { usePaiLensContext } from '@upright/ui/common/upright/core/impact-lenses/pais/common/use-pai-lens-context';
import styled from 'styled-components';

export function EmptyStateAggregates() {
  const context = usePaiLensContext();
  if (!context) {
    return <></>;
  }
  const accessDenied = context.data.access === LensDataAccess.DENIED;
  if (accessDenied) {
    return <EmptyStateNoDataAccess />;
  }
  return (
    <EmptyInfoBox title="No data available" topColor={BouColor.IMPACT_NEGATIVE_PURPLE}>
      <>
        <Text>
          Upright is working to make aggregate results available for SFDR Principal Adverse Impact (PAI) indicators.
          Meanwhile, customers with API access may compute aggregate results themselves based on Upright's company-level
          data. Please contact your Upright contact person if you require assistance.
        </Text>
        <EmptyStateExampleCompanyProfilesCTA />
      </>
    </EmptyInfoBox>
  );
}

const Text = styled.div``;
